import { Component, Injector, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/app-component-base';

@Component({
  selector: 'custom-toggle',
  templateUrl: './custom-toggle.component.html',
  styleUrls: ['./custom-toggle.component.scss'],
  animations: [appModuleAnimation()]
})
export class CustomToggleComponent extends AppComponentBase implements OnInit, OnChanges {

  @Input() value: boolean = false;
  @Input() disabled: boolean = false;
  @Output() toggleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(injector: Injector, private cdr: ChangeDetectorRef) {
    super(injector);
  }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && !changes['value'].firstChange) {
      this.cdr.detectChanges();
    }
  }

  toggle(): void {
    if (this.disabled == false) {
      this.value = !this.value;
      this.toggleChange.emit(this.value);
    }
  }

  resetToggle(): void {
    this.value = false;
  }
}
